import React, { useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import CONSTANTS from '../../constants';

import CompanyAnalysisFieldDisplay from './CompanyAnalysisFieldDisplay';

function CompareCompTabs({ analysisRec, wholeEntity=null }) {

    const [selectedTab, setSelectedTab] = useState(CONSTANTS.COMPANY_CAPABILITY_ANALYSES_TABS[0].title);

    const tabSelected = (key) => {
        setSelectedTab(key)
    }

    //because we pass in company-centric information at this level, and we want all companies to use the same PBI information, including filter
    //we have to pass in the information at the record level.

    let pbiInformation = wholeEntity && wholeEntity.fields && wholeEntity.fields?
        {
            businessSustainabilityPBIReportID: wholeEntity.fields.businessSustainabilityPBIReportID,
            businessSustainabilityPBIDatasetID: wholeEntity.fields.businessSustainabilityPBIDatasetID,
            rDandRegulatoryPBIReportID: wholeEntity.fields.rDandRegulatoryPBIReportID,
            rDandRegulatoryPBIDatasetID: wholeEntity.fields.rDandRegulatoryPBIDatasetID,
            productionAndSupplyPBIReportID: wholeEntity.fields.productionAndSupplyPBIReportID,
            productionAndSupplyPBIDatasetID: wholeEntity.fields.productionAndSupplyPBIDatasetID,
            filtersForPBIs: wholeEntity.fields.filtersForPBIs,
            ...analysisRec.fields
        } 
        : null
    
    return (
        <Tabs
            id={analysisRec.fields.companyName.replace(' ', '_')+'_tab'}
            className="mb-3" 
            onSelect={tabSelected}
            fill >
            {
                CONSTANTS.COMPANY_CAPABILITY_ANALYSES_TABS.map((thisTab) => {
                    return (
                        <Tab eventKey={thisTab.title} title={thisTab.title}>
                            <CompanyAnalysisFieldDisplay
                                pbiInformation={pbiInformation}
                                currentlyShown={selectedTab === thisTab.title}
                                fieldsToDisplay={analysisRec.fields}
                                tabInfo={thisTab} />
                        </Tab>
                    )
                })
            }
        </Tabs>
    )
}

export default CompareCompTabs